module.exports = __webpack_public_path__ + "img/2_2023-04-20--TERRY-FOX-Duo-kidsT.aa4a2f42.jpg";